import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledConfirmTypography = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  color: theme.palette.primary.contrastText,
  paddingLeft: '3rem',
  paddingRight: '3rem',
  whiteSpace: 'pre-line',
  [theme.breakpoints.up('xl')]: {
    paddingLeft: 0,
    paddingRight: 0
  }
}));

export default StyledConfirmTypography;
